/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_LeadInputs */

const en_mk_cmp_linear_lead = /** @type {(inputs: Mk_Cmp_Linear_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linear is the gold standard issue tracker for product teams, and third-party agents can be assigned inside it. KerjaBareng trades some of that depth for something different: non-technical divisions, built-in team chat, approvals, and pricing in rupiah.`)
};

const id_mk_cmp_linear_lead = /** @type {(inputs: Mk_Cmp_Linear_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linear adalah standar emas pelacak issue untuk tim produk, dan agen pihak ketiga bisa di-assign di dalamnya. KerjaBareng menukar sebagian kedalaman itu dengan sesuatu yang berbeda: divisi non-teknis, chat tim bawaan, approval, dan harga dalam rupiah.`)
};

/**
* | output |
* | --- |
* | "Linear is the gold standard issue tracker for product teams, and third-party agents can be assigned inside it. KerjaBareng trades some of that depth for some..." |
*
* @param {Mk_Cmp_Linear_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_lead = /** @type {((inputs?: Mk_Cmp_Linear_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_lead(inputs)
	return en_mk_cmp_linear_lead(inputs)
});